// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import axios from 'axios';
import { deleteAllCookie ,scrollTop} from "@/common/js/v";
import {encrypteParams} from '@/common/js/encryption';
import {baseUrl,oneByOneSet} from "@/common/js/baseUrl"
import  VueI18n from 'vue-i18n'

Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'zh',          //默认语言
  messages: {
    'zh': require('./lang/zh'),
    'en': require('./lang/en')
  }
})
// getFile("http://fastdfs.tamaster.cn/group1/M00/00/00/wKgAyV3vBvGAQ89oAAHzlQyelLY695.png").then(res => {
  
// })
getJson ().then (vData => {
  Vue.config.productionTip = false;
  Vue.prototype.$post = post;
  Vue.prototype.$upLoad = upLoad;
  Vue.prototype.vData = vData;
  oneByOneSet(Vue.prototype,baseUrl)
  window.sessionStorage.setItem('domain',vData.domain);
  window.sessionStorage.setItem('TokenKey',vData.tokenCookieName);
  window.sessionStorage.setItem('cookieDay',vData.cookieDay);
  sessionStorage.setItem("defaultTenantCode", vData.defaultTenantCode);
  // sessionStorage.setItem('tenantCodeName',vData.defaultTenantCode)
  let BASEURL = '';
  BASEURL = `${vData.api}:${vData.port}`;
  axios.interceptors.request.use (
    config => {
      if (
        config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
      ) {
        config.baseURL = vData.upload;
      } else {
        config.baseURL = BASEURL;
      }
      return config;
    },
    error => {
      return Promise.reject (error);
    }
  );

  axios.interceptors.response.use (
    response => {
      return response;
    },
    error => {
      if (error && error.response) {
        switch (error.response.status) {
          case 202:
            console.log (202);
            break;
          case 302:
            console.log (302);
            break;
          case 404:
            console.log (404);
            break;
          case 500:
            console.log (500);
            break;
        }
      }
      return Promise.resolve (error.response);
    }
  );

  router.afterEach(route => {
    if (route.meta.navBol) {
      store.commit('setNavShowBol', false);
    } else {
      store.commit('setNavShowBol', true);
    }
    const sTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (sTop > 130) {
      scrollTop(window, sTop, 0, 1000);
    } else {
      scrollTop(window, sTop, 0, 1000);
    }
    // document.title = route.meta.title;
  });

  new Vue({
    el: '#app',
    i18n,
    store,
    router,
    components: { App },
    template: '<App/>'
  })
})


function getJson () {
  return new Promise ((resolve, reject) => {
    axios
      .get ('/static/data.json', {})
      .then (response => {
        resolve (response.data);
      })
      .catch (error => {
        reject (error);
      });
  });
}

function getFile (url) {
  return new Promise ((resolve, reject) => {
    axios({
            method: 'GET',
            url: url,
            params: {},
            responseType: 'blob'
        }).then(res=>{
            console.log(res)
            // let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
            // let url = window.URL.createObjectURL(blob);
            // window.location.href = url;
        }).catch(err=>{
            console.log(err)
        })
  });
}

const statusCode = {
  4002: '非法请求错误',
  4003: '超时请求错误',
  4004: '重复请求错误'
}

async function post (data) {
  const initParams = data.params || {}; 
  const timeParam = data.url.includes('platform-') && data.url.split('/')[1];
  const params = await encrypteParams({
    ...initParams,
    timeParam,
    tenant_code: sessionStorage.getItem("tenantCodeName")
  });
  ELEMENT.Message.closeAll();
  return new Promise ((resolve, reject) => {
    axios ({
      method: 'post',
      baseURL: '',
      url: data.url+"?tenant_code="+sessionStorage.getItem('tenantCodeName'),
      data: params,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
      },
      withCredentials: true,
      timeout: 100000,
    }).then (response => {
        let data = checkStatus (response);
        if (data) {
          if (data.code == 1000 || data.code == 2000) {
            resolve (data);
          } else {
            if(statusCode[data.code])ELEMENT.Message.error (data.code);
            reject (data);
          }
        }
      })
      .catch (error => {
        reject (error);
      });
  });
}

function checkStatus (response) {
  if (
    response &&
    (response.status === 200 ||
      response.status === 304 ||
      response.status === 400)
  ) {
    return response.data;
  } else {
    let obj = null;
    if (response && response.status === 2002) {
      console.log("this.$route",router)
      localStorage.setItem("historyRoute",router.history.current.fullPath);
      localStorage.removeItem("www_user_name");
      localStorage.removeItem("userInfo");
      sessionStorage.removeItem("userInfo");
      store.commit("setUserName", null);
      // window.location.reload()
      router.push ({
        path: '/login',
      });
      deleteAllCookie();
      localStorage.removeItem ('userMemberInfo');
      localStorage.removeItem ('www_zj_user_name');
      obj = null;
    } else {
      obj = {
        status: -404,
        desc: '网络异常',
      };
    }
    return obj;
  }
}

function upLoad (data) {
  return new Promise ((resolve, reject) => {
    return axios ({
      method: 'post',
      baseURL: '',
      url: '/file/upload.json'+"?tenant_code="+sessionStorage.getItem('tenantCodeName'),
      data: data,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      withCredentials: true,
      timeout: 100000,
    })
      .then (response => {
        let data = checkStatus (response);
        if (data.code == 1000 || data.code == 2000) {
          resolve (data);
        } else {
          ELEMENT.Message.error (data.msg);
          reject (data);
        }
      })
      .catch (error => {
        reject (error);
      });
  });
}



// WEBPACK FOOTER //
// ./src/main.js